import { observable } from "mobx";
import ExemptionApplicationWarningReason from "./exemptionApplicationWarningReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionApplicationProductionResponse {
  /**
   * Exemption application warning reasons.
   */
  @observable
  warningReasons!: ExemptionApplicationWarningReason[];
}
